/* Copyright 2020 Avetti.com Corporation - All Rights Reserved

This source file is subject to the Avetti Commerce Front End License (ACFEL 1.20)
that is accessible at https://www.avetticommerce.com/license */ import React, {
  useState,
} from "react";
import { useSelector, shallowEqual } from "react-redux";

import AnchorElement from "../../functions/AnchorElement.jsx";
import { footerContent } from "./footerContent";

import { I18nContext } from "../../i18n/index";
import Img from "gatsby-image";
import { useStaticQuery, graphql } from "gatsby";

function Footer() {
  const { translate } = React.useContext(I18nContext);
  const data = useStaticQuery(graphql`
    query {
      Linkedin: file(relativePath: { eq: "Linkedin.png" }) {
        childImageSharp {
          fixed(width: 30, height: 30) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      Whatsapp: file(relativePath: { eq: "watsapp.png" }) {
        childImageSharp {
          fixed(width: 30, height: 30) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `);
  const isMobileState = useSelector(
    (state) => state.mainReducer.isMobile,
    shallowEqual
  );

  const [activeFooterSection, setActiveFooterSection] = useState("");

  const renderLinks = (arrContent) => {
    return arrContent.map((content, i) => (
      <li {...content.parent.attributes} key={i}>
        {content.children.map((childContent, i) => {
          return <AnchorElement {...childContent} key={i} />;
        })}
      </li>
    ));
  };

  const handleOnClickFooterSection = (e) => {
    const { target: clickedFooterSectionTarget } = e.target.dataset;
    setActiveFooterSection(
      activeFooterSection !== clickedFooterSectionTarget &&
        clickedFooterSectionTarget
    );
  };

  const handleWhatIconToDisplay = (footerSectionName) => {
    return activeFooterSection === footerSectionName
      ? `remove_circle`
      : `add_circle`;
  };
  return (
    <footer id="footer">
      <div className="new-footer" style={{ maxWidth: "100%" }}>
        <div className="columns " style={{ maxWidth: "100%" }}>
          <div className="footer-container">
            {isMobileState ? (
              <>
                <div
                  className="liHead"
                  id="about-menu"
                  onClick={(e) => handleOnClickFooterSection(e)}
                  data-target="about"
                  aria-controls="about"
                  aria-expanded={activeFooterSection === "about"}
                >
                  {translate("aboutMobile")}
                  <i className="material-icons footer-icon" data-target="about">
                    {handleWhatIconToDisplay("about")}
                  </i>
                </div>
                <div
                  className="menu-footer"
                  aria-labelledby="about-menu"
                  role="region"
                  id="about"
                  style={{
                    display: activeFooterSection === "about" ? "block" : "none",
                  }}
                >
                  <ul>{renderLinks(footerContent.about)}</ul>
                </div>
                <div
                  className="liHead"
                  id="shop-menu"
                  onClick={(e) => handleOnClickFooterSection(e)}
                  data-target="shop"
                  aria-controls="shop"
                  aria-expanded={activeFooterSection === "shop"}
                >
                  Policies & Rules
                  <i className="material-icons footer-icon" data-target="shop">
                    {handleWhatIconToDisplay("shop")}
                  </i>
                </div>
                <div
                  className="menu-footer"
                  id="shop"
                  aria-labelledby="shop-menu"
                  role="region"
                  style={{
                    display: activeFooterSection === "shop" ? "block" : "none",
                  }}
                >
                  <h1>Quick links</h1>
                  <ul>{renderLinks(footerContent.shop)}</ul>
                </div>
                <div
                  className="liHead"
                  id="network-menu"
                  onClick={(e) => handleOnClickFooterSection(e)}
                  data-target="network"
                  aria-controls="network"
                  aria-expanded={activeFooterSection === "network"}
                >
                  {translate("networkMobile")}
                  <i
                    className="material-icons footer-icon"
                    data-target="network"
                  >
                    {handleWhatIconToDisplay("network")}
                  </i>
                </div>
                <div
                  className="menu-footer"
                  id="network"
                  aria-labelledby="network-menu"
                  role="region"
                  style={{
                    display:
                      activeFooterSection === "network" ? "block" : "none",
                  }}
                >
                  <ul>{renderLinks(footerContent.network)}</ul>
                </div>
              </>
            ) : (
              <>
                <div className="liHead" id="about-menu">
                  {translate("About")}
                  <i
                    className="hidden-md hidden-lg hidden-sm fas fa-plus-circle global--one-column pull-right"
                    id="global--mobile-about-expand"
                  ></i>
                </div>
                <div className="menu-footer" id="about">
                  <div className="footerHead">Quick links</div>
                  <ul>{renderLinks(footerContent.about)}</ul>
                </div>

                <div className="liHead" id="shop-menu">
                  {translate("shopMobile")}
                  <i
                    className="hidden-md hidden-lg hidden-sm fas fa-plus-circle global--one-column pull-right"
                    id="global--mobile-shop-expand"
                  ></i>
                </div>

                <div className="menu-footer" id="shop">
                  <div className="footerHead">Get to know</div>
                  <ul>{renderLinks(footerContent.shop)}</ul>
                </div>

                <div className="liHead" id="network-menu">
                  {translate("networkMobile")}
                  <i
                    className="hidden-md hidden-lg hidden-sm fas fa-plus-circle global--one-column pull-right"
                    id="global--mobile-network-expand"
                  ></i>
                </div>

                <div className="menu-footer" id="network">
                  <div className="footerHead">Help</div>
                  <ul>{renderLinks(footerContent.network)}</ul>
                </div>
                <div className="liHead" id="services-menu">
                  {translate("servicesMobile")}
                  <i
                    className="hidden-md hidden-lg hidden-sm fas fa-plus-circle global--one-column pull-right"
                    id="global--mobile-services-expand"
                  ></i>
                </div>
                <div className="menu-footer" id="services">
                  <div className="footerHead">Connect Us</div>
                  <ul>
                    <li className="socialMedia">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.linkedin.com/company/avetti-com-corporation"
                      >
                        <Img
                          fixed={data.Linkedin.childImageSharp.fixed}
                          alt="LinkedIn Logo"
                        />
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.twitter.com/avetticom"
                      >
                        <Img
                          fixed={data.Whatsapp.childImageSharp.fixed}
                          alt="What's App Logo"
                        />
                      </a>
                    </li>
                  </ul>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
